import React from 'react';
import { View, Text } from 'react-native';
import cstyles from './style';

import GatsbyLink from 'gatsby-link';

export const SUPPORT = ({ lang }) => (
  <View>
    <Text style={cstyles.page_header}>{lang.SUPPORT.toUpperCase()}</Text>
    <Text style={cstyles.page_text}>{lang.ABOUT_TEXT}</Text>
  </View>
);



// WEBPACK FOOTER //
// ./src/comp/pages/support.js